import { render } from "./DescargarComprobante.vue?vue&type=template&id=00e4c77e&scoped=true"
import script from "./DescargarComprobante.vue?vue&type=script&lang=js"
export * from "./DescargarComprobante.vue?vue&type=script&lang=js"

import "./DescargarComprobante.vue?vue&type=style&index=0&id=00e4c77e&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e4c77e"]])

export default __exports__